import { Column, Columns, Flex, Text } from "@dna/react";
import { makeStyles } from "@material-ui/core";
import React from "react";
import { ReactComponent as CheckCircleFill } from "../../images/checkCircle-fill.svg";
import styles from "./Layout.module.scss";

export const SuccessBanner = (props: {text: string}) => {
  const useStyles = makeStyles({
    greenFill: { fill: '#008A00'}
  });
  const classes = useStyles();
  
  return (
          <Columns
            css={{
              backgroundColor: "green-lighter",
            }}
            UNSAFE_style={{
              wordBreak: "break-word",
            }}
          >
            <Column
              width="content"
            >
              <Flex UNSAFE_className={styles.successIconColumn} >
                <CheckCircleFill className={classes.greenFill} ></CheckCircleFill>
              </Flex>
            </Column>
 
            <Column
            >
              <Flex  UNSAFE_className={styles.successTextColumn}>
                <Text
                  level="small"
                  css={{
                    color: "green-mid",
                  }}
                  as="strong"
                >
                  {props.text}
                </Text>
              </Flex>
            </Column>
          </Columns>
  );
}